<ng-container *ngIf='!loading, else isLoading'>
  <ng-container *ngIf='groupedAWBs && groupedAWBs.length > 0, else noAWBs'>
    <mat-card class='mat-elevation-z0 mb--md' *ngFor="let group of groupedAWBs">
      <mat-card-content class='pt--none'>
        <div class='row'>
          <div class='column--12'>
            <div class='responsive-table'>
              <table mat-table [dataSource]="group.awbs" class="mat-elevation-z0">
                <ng-container matColumnDef="shipDate">
                  <th mat-header-cell *matHeaderCellDef style='width: 20%'>Date</th>
                  <td mat-cell class='text--sm' *matCellDef="let element" notranslate>
                    {{ element.shipDate | timeToString : DATE_FORMAT : defaultTimezone }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="awbNumber">
                  <th mat-header-cell *matHeaderCellDef style='width: 20%'>AWB</th>
                  <td mat-cell class='text--sm' *matCellDef="let element" notranslate>
                    <span class='text--primary-green' style='cursor: pointer' (click)='openTrackingFromAWB(element)'>
                      {{ element.awbNumber }}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="lastMileProvider">
                  <th mat-header-cell *matHeaderCellDef style='width: 20%'>Courier</th>
                  <td mat-cell class='text--sm' *matCellDef="let element" notranslate>
                    {{ element.lastMileProviderName }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="destinationAirport">
                  <th mat-header-cell *matHeaderCellDef>Destination</th>
                  <td mat-cell class='text--sm' *matCellDef="let element" notranslate>
                    {{ element.destinationAirport }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef>Status</th>
                  <td mat-cell class='text--sm' *matCellDef="let element" notranslate>
                    {{ element.trackingStatus ? element.trackingStatus : 'Not Available' }}
                  </td>
                </ng-container>
  
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>
  <ng-template #noAWBs>
    <div class='row justify-content-center'>
      <div class='column--12 align-center'>
        <div style='width: 220px; margin: 0 auto;'>
          <img src='{{ CDN_URL }}/admin/images/empty-history_animated.svg' />
          <p>No AWBs found for pickup</p>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-template #isLoading>
  <div class='align-center mt--lg'>
    <app-loading></app-loading>
  </div>
</ng-template>
